import {
    SET_ADDRESS_DROPDOWN_LIST
} from './AddressSearchType';


const reducers = (state = {}, action: any) => {
    if (action.type === SET_ADDRESS_DROPDOWN_LIST) {
        const nextState: any = {
            ...state
        };

        if (action.target === 'thirdParty') {
            nextState.thirdPartyAddressDropDownList = action.addressDropDownList;
        }

        if (action.target === 'location') {
            nextState.locationAddressDropDownList = action.addressDropDownList;
        }

        if (!action.target) {
            nextState.addressDropDownList = action.addressDropDownList;
        }

        return nextState;
    }
    else {
        return state;
    }
}

export {
    reducers
}